import angular from 'angular';

angular.module('cloudX').directive('cxCalendar', function() {
  return {
    restrict: 'E',
    template: require('./calendar.html'),
    scope: false,
  };
});
